export const SettingsFooter = {
  ContinueButton: {
    show: (el) => !el.getUserSettings('autoSaveSettings'),
    hide: (el) => el.getUserSettings('autoSaveSettings'),
    text: '{{ settings.footer.update | polyglot }}',
    onClick: async (ev, el) => {
      await el.call('closeRouterModal')
      const Canvas = el.getCanvas()
      Canvas.Iframe.update()
      el.getEditorPanels()?.update()
      el.call('openNotification', {
        title: el.call('polyglot', 'settings.footer.saved.title'),
        message: el.call('polyglot', 'settings.footer.saved.message'),
        type: 'success'
      })
    }
  },
  CheckboxField: {
    margin: '- auto - -',
    checked: (el) => el.getUserSettings('autoSaveSettings'),
    onChange: (ev, el) => {
      el.setUserSettings(
        'autoSaveSettings',
        Boolean(ev.target.checked)
        // {
        //   preventUpdate: val ? ['CanvasModal'] : ['Modal', 'Canvas']
        // }
      )
      el.parent.update()
    },
    Icon: {},
    Span: {
      text: '{{ settings.footer.autoUpdate | polyglot }}'
    }
  },
  Flex: {
    gap: 'B2',
    // 6 text-link buttons in one unwrapped row is wider than any narrow
    // host (a settings drawer, a catalog cell) — reflow onto multiple
    // lines instead of forcing the footer wider than its container.
    wrap: 'wrap',
    childExtends: ['IconText', 'DocsLink'],
    // SIZE-1 item 4 remainder (tickets/sonnet.md, WAVE-G, 2026-08-14/15):
    // neither `IconText` (framework built-in) nor brand's `DocsLink` sets
    // any padding/minHeight, so all 6 rows measured 17px tall — exactly
    // text-glyph height, under the touch/click comfortable floor. One
    // `childProps` entry covers all 6 uniformly rather than repeating the
    // fix per child. Same two-tier token family the chat-lane pass used for
    // the identical "small inline click target" shape this same sweep
    // (workspace a986e7ee, ChatSidebarMore): `iconLg` (24px) unconditional,
    // `controlH` (44px, Apple HIG) added under `'@coarse'` for touch.
    childProps: {
      padding: 'V W',
      minHeight: 'iconLg',
      '@coarse': { minHeight: 'controlH' }
    },
    ConvertToDomql3: {
      color: 'inactive',
      text: '{{ settings.footer.convertDomql3 | polyglot }}',
      onClick: async (ev, el) => {
        await el.convertToDomql3()
      }
    },
    RestoreTypes: {
      color: 'inactive',
      text: '{{ settings.footer.restoreTypes | polyglot }}',
      onClick: async (ev, el) => {
        await el.restoreMissingTypes()
      }
    },
    RestoreComponents: {
      color: 'inactive',
      text: '{{ settings.footer.restoreComponents | polyglot }}',
      onClick: async (ev, el) => {
        await el.restoreMissingComponents()
      }
    },
    ResetSettings: {
      color: 'inactive',
      text: '{{ settings.footer.resetSettings | polyglot }}',
      onClick: (ev, el) => {
        el.setAllUserSettings(
          {
            optimizedMode: false,
            thumbnailPreview: false,
            allowInitialSelection: false,
            openOnDblClick: true,
            showGrid: true,
            allowTabs: true,
            allowZoombar: true,
            allowAutoPosition: true,
            allowTabPreview: true,
            useAnimations: true
          },
          {
            message: 'Reset settings'
          }
        )
      }
    },
    ClearCookies: {
      color: 'inactive',
      text: '{{ settings.footer.cleanCookies | polyglot }}',
      onClick: (ev, el) => {
        el.call('removeCookie', 'topNavbarActive')
        el.call('removeCookie', 'bottomNavbarActive')
        el.call('removeCookie', 'globalTheme')
        el.call('removeCookie', 'sceneTheme')
        el.call('removeCookie', 'globalTheme')
        el.call('removeCookie', 'framework')
        el.call('removeCookie', 'pkgManager')
        el.call('removeCookie', 'language')
        el.call('removeCookie', 'activeProject')
        el.call('removeCookie', 'installTab')
        el.call('removeCookie', 'isSidebarSticky')
        el.call('removeCookie', 'componentShowFilter')
        el.call('removeCookie', 'navbarPlacement')
        el.call('removeCookie', 'presentMode')
        el.call('removeCookie', 'showErrorBanner')
        el.call('removeCookie', 'thumbnailPreview')
        el.call('removeCookie', 'optimizedMode')
        el.call('removeCookie', 'showGrid')
        el.call('removeCookie', 'explorerAutoscroll')
        el.call('removeCookie', 'debuggingMode')
        el.call('removeCookie', 'allowCanvasReplaceRouter')
        el.call('removeCookie', 'useDomql3')
        el.call('removeCookie', 'useGlassmorphism')
        el.call('removeCookie', 'allowAutoPosition')
        el.call('removeCookie', 'allowInitialSelection')
        el.call('removeCookie', 'openOnDblClick')
        el.call('removeCookie', 'allowTabs')
        el.call('removeCookie', 'showReferences')
        el.call('removeCookie', 'allowTeamCursors')
        el.call('removeCookie', 'allowFilesidebarPreview')
        el.call('removeCookie', 'allowTabPreview')
        el.call('removeCookie', 'useAnimations')
        el.call('removeCookie', 'allowZoombar')
        el.call('removeCookie', 'previewSize')
        el.call('removeCookie', 'zoomLevel')
        el.call('removeCookie', 'userId')
        el.call('removeCookie', 'name')
        el.call('removeCookie', 'email')
        el.call('openNotification', {
          title: el.call('polyglot', 'settings.footer.cookiesCleared.title'),
          message: el.call('polyglot', 'settings.footer.cookiesCleared.message'),
          type: 'success'
        })
      }
    },
    ClearCache: {
      color: 'inactive',
      text: '{{ settings.footer.cleanCache | polyglot }}',
      fontWeight: 400,
      onClick: async (ev, el) => {
        await el.clearCache()
      }
    }
  },
  flow: 'x',
  gap: 'B2',
  margin: 'A2 -X2 B2',
  align: 'center space-between',
  // Three top-level groups (ContinueButton / CheckboxField / the link Flex)
  // side by side with no wrap policy forced this row wider than its
  // container whenever the link group above already needed a second line.
  wrap: 'wrap'
}
